import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getInhabitantProfileOptions } from '../../../../../api'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../User'
import { FLAT_FORM_FIELD_NAME_CONTRACTS } from '../../FlatForm.constants'

import { getInhabitantFieldApiParams } from './InhabitantField.utils'

function InhabitantField(props) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const apiParams = getInhabitantFieldApiParams(
    values[FLAT_FORM_FIELD_NAME_CONTRACTS]
  )

  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Select={UserSelect}
      apiParams={apiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Flat.InhabitantPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Flat.InhabitantLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getInhabitantProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default InhabitantField
